// extracted by mini-css-extract-plugin
export default {"wrapper":"UserTicketsStats_wrapper__gWbq7","button":"UserTicketsStats_button__G+6gi"};